/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { colors, Container, Stack, Text, H2, Body } from "@carrotfertility/carotene"
import { Link as TextLink } from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"
import { useUserRole } from "../partner-access/hooks/usePartnerAccess"
import { employeeOnlyHeaderText, employeeOnlyText, employeeOnlyLink } from "./employeeOnlySpaceContent"
import { FormattedMessage, useIntl } from "react-intl"

const EmployeeOnlySpaceContainer = ({ ...props }): JSX.Element => {
  const { isPartnerAccessingAccount, isUserRoleLoading } = useUserRole()
  const intl = useIntl()

  if (isUserRoleLoading) {
    return null
  }

  if (isPartnerAccessingAccount) {
    return (
      <Container
        background={colors.base.lightGrey}
        padding={"48px"}
        borderRadius={"8px"}
        width={["100%", null, null, "616px"]}
        height={[null, null, null, "240px"]}
      >
        <Stack spacing={"12px"}>
          <Container>
            <H2 color={colors.base.black80}>{intl.formatMessage(employeeOnlyHeaderText)}</H2>
          </Container>
          <Container>
            <Body size={"small"}>{intl.formatMessage(employeeOnlyText)}</Body>
          </Container>
          <Container>
            <Text color={colors.base.black80} as="p" size={"small"}>
              <FormattedMessage
                defaultMessage="Questions? <link>Contact us.</link>"
                values={{
                  link: (linkContent) => (
                    <TextLink component={RouterLink} to={employeeOnlyLink}>
                      <Text color={colors.base.black80} size={"small"}>
                        {linkContent}
                      </Text>
                    </TextLink>
                  )
                }}
              />
            </Text>
          </Container>
        </Stack>
      </Container>
    )
  }

  return <div>{props.children}</div>
}

export default EmployeeOnlySpaceContainer
